import { deriveYears } from '../../utils/index.js';
import { Year } from './Year.js';
import { YearsList } from '../../styled.js';
import { jsx } from 'react/jsx-runtime';

function YearPicker() {
  var years = deriveYears({
    date: new Date(),
    total: 100
  });
  return /*#__PURE__*/jsx(YearsList, {
    children: years.map(function (year) {
      return /*#__PURE__*/jsx(Year, {
        date: year
      }, year.toString());
    })
  });
}

export { YearPicker };
